export const GlobalSearchPath = {
    Account: "accounts",
    Account2: "accounts-v2.0",
    Lead: "leads",
    Contact: "contacts",
    Estimate: "estimates",
    Invoice: "invoicing",
    Opportunity: "opportunities",
    Warehouse: "locations",
    Product: "products",
    Purchases: "purchases",
    Case: "cases",
    SavedSearch: "saved-searches",
    SerialNo:"SerialNo",
    BillOrder:"BillOrder",
    SalesOrder:"sales-order",
    Territory: "territory",
    InventoryTransfer:"inventoryTransfer",
    InventoryAdjustment:"inventoryAdjustment",
    CreditMemo:"credit-memo",
    CustomerRma:"customer-returns"
};
